import React from 'react';

const SuccessIcon = props => (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M70 35C70 54.33 54.33 70 35 70C15.67 70 0 54.33 0 35C0 15.67 15.67 0 35 0C54.33 0 70 15.67 70 35Z" fill="#53D37F" />
        <path fillRule="evenodd" clipRule="evenodd" d="M52.79 22.81C53.3367 23.3568 53.3367 24.2432 52.79 24.7899L29.69 47.8899C29.1432 48.4367 28.2568 48.4367 27.71 47.8899L17.2101 37.3899C16.6633 36.8432 16.6633 35.9568 17.2101 35.41C17.7568 34.8633 18.6432 34.8633 19.1899 35.41L28.7 44.9201L50.81 22.81C51.3568 22.2633 52.2432 22.2633 52.79 22.81Z" fill="white" />
    </svg>
);

export default SuccessIcon;